import React, { FC, useState } from 'react';
import { FilterableField } from 'components/organisms/tasks/fields';
import { GroupedFilter } from 'components/organisms/tasks/grouped-filter-popover';
import { AvailabilityFilter as AvailabilityFilterT } from '../types';
import { AvailabilityFilterDrawer } from './drawer';
import { AvailabilityFilterTrigger } from './trigger';

interface Props {
  availabilityFilter?: AvailabilityFilterT;
  onFilterChange: (params: {
    availabilityFilter?: AvailabilityFilterT;
    filter: GroupedFilter;
  }) => void;
  appliedFilter: GroupedFilter;
  userFields: FilterableField[];
  isHoursPerWeek: boolean;
}
export const AvailabilityFilter: FC<Props> = ({
  availabilityFilter,
  onFilterChange,
  appliedFilter,
  userFields,
  isHoursPerWeek,
}) => {
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <>
      <AvailabilityFilterTrigger
        availabilityFilter={availabilityFilter}
        onClick={() => setModalVisible(true)}
        onReset={() => {
          onFilterChange({ filter: appliedFilter });
        }}
        isHoursPerWeek={isHoursPerWeek}
      />
      <AvailabilityFilterDrawer
        availabilityFilter={availabilityFilter}
        appliedFilter={appliedFilter}
        visible={modalVisible}
        userFields={userFields}
        onCancel={() => setModalVisible(false)}
        onFind={(nextFilter) => {
          onFilterChange(nextFilter);
          setModalVisible(false);
        }}
        isHoursPerWeek={isHoursPerWeek}
      />
    </>
  );
};
